/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GenericSuccessResponseContent
 */
export interface GenericSuccessResponseContent {
    /**
     * 
     * @type {string}
     * @memberof GenericSuccessResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the GenericSuccessResponseContent interface.
 */
export function instanceOfGenericSuccessResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function GenericSuccessResponseContentFromJSON(json: any): GenericSuccessResponseContent {
    return GenericSuccessResponseContentFromJSONTyped(json, false);
}

export function GenericSuccessResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericSuccessResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function GenericSuccessResponseContentToJSON(value?: GenericSuccessResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

